import { render, staticRenderFns } from "./VendorLinkingDetail.vue?vue&type=template&id=44d76f7e&"
import script from "./VendorLinkingDetail.vue?vue&type=script&lang=js&"
export * from "./VendorLinkingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports